import { render, staticRenderFns } from "./MoveToNextStageTournament.vue?vue&type=template&id=06508b6b&scoped=true"
import script from "./MoveToNextStageTournament.vue?vue&type=script&lang=js"
export * from "./MoveToNextStageTournament.vue?vue&type=script&lang=js"
import style0 from "./MoveToNextStageTournament.vue?vue&type=style&index=0&id=06508b6b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06508b6b",
  null
  
)

export default component.exports